import { ModuleContent } from '../contract';

/**
 * Content for the Segment module.
 * A segment acts as a sub-container that groups child modules.
 * Its primary content is in its children (ModuleData.Children).
 */
export type SegmentModuleContent = {
	name?: string;
	passwordProtected?: boolean;
	expandable: {
		enabled: boolean;
		expandedByDefault: boolean;
		/** When true, the segment is completely hidden when collapsed (no preview shown). */
		completelyHidden: boolean;
		/** When true, the preview text acts as the expand/collapse button. */
		previewAsButton: boolean;
		previewImageUrl?: string;
		previewText?: string;
	};
	columns?: number;
	mobileColumns?: number;
	gap?: string;
	mobileGap?: string;
	justifyContent?: 'start' | 'center' | 'end' | 'space-between' | 'space-around';
	alignItems?: 'start' | 'center' | 'end';
};

export function isSegmentModuleContent(content: ModuleContent): content is SegmentModuleContent {
	const c = content as SegmentModuleContent;
	return c && typeof c.expandable === 'object' && typeof c.expandable.enabled === 'boolean';
}
